import { createFileRoute } from '@tanstack/react-router';
import { TenantSecurityForm } from '@/components/tenants/TenantSecurityForm';
import { TenantLaunchTokenForm } from '@/components/tenants/TenantLaunchTokenForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/security')({
  component: TenantSecurityRoute,
});

function TenantSecurityRoute() {
  const { tenantCode } = Route.useParams();

  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground">
        Manage authentication settings for <span className="font-semibold">{tenantCode}</span>.
      </div>
      <TenantSecurityForm tenantCode={tenantCode} />
      {/*
        Both authentication styles are configurable here, and an instance runs one of them — whichever
        its platform config selects (CAE-710). Which one is live is an instance-level fact rather than
        a per-tenant one, so both forms are shown rather than one being hidden on a guess.
      */}
      <div className="pt-8 mt-4 border-t">
        <TenantLaunchTokenForm tenantCode={tenantCode} />
      </div>
    </div>
  );
}
